// extracted by mini-css-extract-plugin
export default {"tooltipLine":"style--tooltipLine--e6fd2f","text":"style--text--21b995"};